import { Link } from "react-router-dom";
import Wrapper from "../../components/sectionWrapper";
import { media } from "../../libs/media";
import Messages from "./translations/CheckOutFocus.json";
// import Messages from "./translations/Secure.json";
import { useLangContext } from "../../components/translateContext";
// import buttonText from "../../translations/button.json";

import buttonText from "../../../src/translations/button.json";
import { Bounce } from "react-reveal";
import { Icon } from "@iconify/react";
export default function CheckOutCustom() {
  const { Lang } = useLangContext();
  const Infos = { msg: Messages[Lang], button: buttonText[Lang] };
  return (
    <div className="bg-white pb-10 md:pb-20 z-10 overflow-hidden relative px-4  md:px-10 lg:px-8 xl:px-8 xl:max-w-screen-xl mx-auto">
      <div className="grid md:flex md:w-full  ">
        <div className=" w-full md:w-6/12 p-1">
          <div className="mt-10 relative flex-inline  justify-left align-left w-full">
            <div className="mb-10">
              <h4 className="text-qosorange">{Infos.msg.HelloText}</h4>
            </div>
          </div>
          <div className=" grid gap-4 mt-4 mb-6">
            <div className="">
              <h3 className=" md:w-11/12 lg:w-10/12 xl:10/12 ">
                {Infos.msg.Start}
              </h3>
            </div>
            <div className="pt-2 ">
              <p className="text-qosblackgray font-normal md:text-Mobilw22  md:w-11/12 lg:w-11/12 ">
                {Infos.msg.GetText}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-qosOneGray w-full md:w-6/12 px-20 rounded-lg">
          <img
            src={media.Logos.CheckOut.CheckOutCustomRight}
            alt=""
            className="h-full w-full  md:h-full md:w-full "
          />
        </div>
      </div>
    </div>
  );
}
